<template>
  <div class="i-charts ipx-1">
    <div v-if="debug" class="i-charts-stop">
      <el-switch v-model="run" active-color="#13ce66" inactive-color="#ff4949" active-text="滚动图">
      </el-switch>
      <el-button @click="drawAgain" type="success" icon="el-icon-refresh" circle></el-button>
    </div>

    <aside-tab class="imt-1" border :tabs="tabLists" v-model="currentTab"></aside-tab>


    <!-- <el-popover
      placement="top-start"
      title="Alarm Detail"
      width="200"
      trigger="hover"
      :content="alarmText(datas)">
      <img class="i-charts-alarm" slot="reference" :src="marker_alarm" v-if="onAlarm(datas)" />
    </el-popover> -->

    <div v-if="currentTab == 0">
      <span class="attach-state elevation-10" :class="status(datas.Status)" key="attachState1">{{status(datas.Status)}}</span>

      <el-card class="elevation-0" key="mcu">
        <p class="caption description">
          Container：<span class="caption-name highlight">{{datas.ContainerName || '- -'}}</span>
          <br/>
          <span style="margin-left: 0em;">
            Device<span style="margin-left:1.5rem">：</span><span class="caption-name highlight">{{datas.DeviceName || '- -'}}</span>
          </span>
        </p>
        <el-row type="flex" style="min-width: 500px;">
          <el-col :span="12" class="grow equal">
            <chart-mcu :datas="datas" :on-alarm="!!datas.CPUAlarm">CPU(%)</chart-mcu>
          </el-col>
          <el-col :span="12" class="grow equal">
            <chart-memory :datas="datas" :on-alarm="!!datas.MemoryAlarm">Memory(%)</chart-memory>
          </el-col>
        </el-row>

      </el-card>

      <el-card class="elevation-0" key="battery">
        <p class="caption">Battery(%)</p>
        <chart-battery :datas="datas" prop-name="Battery" :on-alarm="!!datas.BatteryAlarm"></chart-battery>
      </el-card>

      <el-card class="elevation-0" key="signal">
        <p class="caption">Cell Signal</p>
        <chart-signal :datas="datas" prop-name="CellSignal"></chart-signal>
      </el-card>

    </div>
    <div v-show="currentTab == 1">
      <span class="attach-state elevation-10" :class="status(datas.Status)" key="attachState2">{{status(datas.Status)}}</span>

        <el-card class="elevation-0" key="door">
          <p class="caption description">
            Container：<span class="caption-name highlight">{{datas.ContainerName || '- -'}}</span>
            <br/>
            <span style="margin-left: 0em;">
              Device<span style="margin-left:1.5rem">：</span><span class="caption-name highlight">{{datas.DeviceName || '- -'}}</span>
            </span>
          </p>
          <chart-door :datas="datas" :on-alarm="!!datas.DoorAlarm"></chart-door>
        </el-card>

        <el-card class="elevation-0" key="temperature">
          <p class="caption"></p>
          <chart-temperature :datas="datas" :item-historys="itemHistorys" ref="temperature"
            :on-alarm="!!datas.TAlarm" :run="run"></chart-temperature>
        </el-card>

        <el-card class="elevation-0" key="humidity">
          <p class="caption"></p>
          <chart-humidity :datas="datas" :item-historys="itemHistorys" ref="humidity"
            :on-alarm="!!datas.HAlarm" :run="run"></chart-humidity>
        </el-card>

        <el-card class="elevation-0" key="speed">
          <p class="caption"></p>
          <chart-speed :datas="datas" :item-historys="itemHistorys" ref="speed"
            :on-alarm="!!datas.GAlarm" :run="run"></chart-speed>
        </el-card>
    </div>
  </div>
</template>

<script>
import { status } from '../convert'
import ChartHumidity from './chart-humidity-h'
import ChartMcu from './chart-mcu'
import ChartTemperature from './chart-temperature-h'
import ChartSpeed from './chart-speed-h'
import ChartDoor from './chart-door'
import ChartBattery from './chart-battery'
import ChartSignal from './chart-signal'
import ChartMemory from './chart-memory'
import AsideTab from '../aside-tab'
import * as Convert from '../convert'
export default {
  props: {
    datas: {
      type: Object,
      default: () => ({})
    },
    itemHistorys: {
      type: Array,
      default: () => ({})
    },
    tab: {
      type: Number,
      default: 0
    },
    tabLists: {
      type: Array,
      default: () => ([])
    }
  },
  data:() => ({
    show: true,
    currentTab: 0,
    run: true,
    debug: process.env.NODE_ENV !== 'production' && false
  }),
  watch: {
    tab(val) {
      this.currentTab = parseInt(val)
    },
    datas() {
      // this.drawAgain()
    },
    itemHistorys() {
      // this.drawAgain()
    },
  },
  methods: {
    status,
    drawAgain() {
      this.$refs.temperature && this.$refs.temperature.redraw()
      this.$refs.speed && this.$refs.speed.redraw()
      this.$refs.humidity && this.$refs.humidity.redraw()
      // console.log('重画图表')
      // this.show = false
      // setTimeout(() => {
      //   this.show = true
      // }, 0)
    },
    reflow() {
      this.$refs.temperature.reflow()
      this.$refs.humidity.reflow()
      this.$refs.speed.reflow()
    },
    onAlarm: (item) => {
      return Convert.onAlarm(item)
    },
    alarmText: (item) => {
      return Convert.alarmText(item)
    }
    // ConvertInfo: Convert
  },
  created() {
    this.marker_alarm = require('../../../assets/icon/alarm.gif')
  },
  mounted() {

    // setTimeout(() => {
    //   this.show = true
    // }, 300)
    // this.$nextTick(() => {
    //   //this.show = true
    // })
  },
  components: {
    AsideTab,
    ChartHumidity,
    ChartMcu,
    ChartTemperature,
    ChartSpeed,
    ChartDoor,
    ChartBattery,
    ChartSignal,
    ChartMemory
  }
}
</script>

<style lang="scss" scoped>
.i-charts /deep/ .el-card__body {
  padding: 10px;
}
.i-charts-stop {
  position: absolute;
  left: 20px;
  top: 25px;
  z-index: 1;
}
.i-charts-alarm {
  position: absolute;
  top: 100px;
  left: 20px;
  width: 40px;
  height: 40px;
  z-index: 100;
}
.caption {
  //font-size: 20px;
  color: #303133;
  .caption-name {
    font-size: 20px;
    color: #606266;
    &.highlight {
      color: #009FDB;
    }
  }
  &.description {
    font-size: 20px;
    margin-top: 0;
  }
}
.attach-state {
  position: absolute;
  top: 62px;
  right: 20px;
  color: #FFF;
  padding: 0.5em 1em;
  border-radius: 4px;
  &.Activated {
    background-color: #050505;
  }
  &.Connected {
    background-color: #FF9800;
  }
  &.Attached {
    background-color: #4CAF50;
  }
  &.Offline {
    background-color: #607D8B;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/charts/index.vue